var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sidebar-filtros",modifiers:{"sidebar-filtros":true}}],staticClass:"btn-icon mx-1",attrs:{"variant":"primary"}},[_c('i',{staticClass:"mdi mdi-filter mdi-24px"})])}
var staticRenderFns = []

export { render, staticRenderFns }